export const trygTheme = {
    brand: '#dc0000',
    lightBrown: '#FFF8EA',
    yellow: '#FDB363',
    black: '#262626',
    error: '#B00000',
    warning: '#EE2233',
    line: '#E1E1E1',
    white: '#ffffff',
    link: '#B00000',
    border: '#e1e1e1',
    grey80: '#535C5E',
    grey60: '#767676',
    grey40: '#989898',
    grey20: '#e1e1e1',
    grey10: '#ededed',
    grey0: '#f7f7f7',
    hover: '#B00000',
}
